import { render } from "./chartTable.vue?vue&type=template&id=63c99c0a"
import script from "./chartTable.vue?vue&type=script&lang=js"
export * from "./chartTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__